<template>
    <div class="resetNickname">
        <div class="resetNickname-form" @keyup.enter="putMemberNickname()">
            <lgn-form-item label-position="left">
                <div slot="label">信箱</div>
                <span slot="input" class="resetNickname-form-value">{{email}}</span>
            </lgn-form-item>
            <lgn-form-item label-position="left">
                <div slot="label">原暱稱</div>
                <span slot="input" class="resetNickname-form-value">{{sourceNickname}}</span>
            </lgn-form-item>
            <lgn-form-item label-position="left">
                <div slot="label">新暱稱</div>
                <lgn-input slot="input" type="text" class="" placeholder="" v-model="newNickname"></lgn-input>
            </lgn-form-item>
            <div class="resetNickname-form-submit">
                <el-button class="resetNickname-form-submit-button main-button" @click="putMemberNickname()">送出</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import lgnFormItem from '@/lgnComponents/lgnForm/lgnFormItem.vue'
import * as api from "@/script/apiService/api.js"
export default {
    name: "resetNickname",
    data(){
        return{
            userInfo: null,
            id: "",
            sourceNickname: "",
            email: "",
            newNickname: ""
        }
    },
    components: {
        lgnInput,
        lgnFormItem
    },
    methods: {
        async putMemberNickname(){
            if(this.newNickname.trim() == 0){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "暱稱不得為空!"
                })
                return false
            }
            let data = {
                email: this.email,
                nickname: this.newNickname
            }
            let res = await api.putMemberNickname(this.id, data);
            if(!res.error_status){
                this.userInfo.nickname = this.newNickname;
                this.$store.commit({
                    type: 'setUserInfo',
                    userInfo: this.userInfo
                });
                this.sourceNickname = this.newNickname;
                this.newNickname = "";
            } else if(res.error_status == '400'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "請確認輸入的內容!"
                })
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        }
    },
    activated(){
        this.userInfo = this.$store.state.userInfo;
        let userInfo = JSON.parse(JSON.stringify(this.userInfo));
        this.email = userInfo.email;
        this.sourceNickname = userInfo.nickname;
        this.id = userInfo.id;
    },
}
</script>